module.exports = __webpack_public_path__ + "img/app-version.d6812c2a.png";